module.exports = __webpack_public_path__ + "img/recent-work-02.3b5be911.jpg";